import {
  useLoaders,
  useTableColumnsProducto,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared";
import {
  SearchComponente,
  GeneralTable,
} from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { IDataProducto } from "@/shared/interfaces";
import { Button, Grid, IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import { useFetchUbicacionProductoSimple } from "@/shared/actions/erp";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import AddIcon from "@mui/icons-material/Add";
import { IUbicacionProducto } from "@/shared/interfaces/erp/inventario";
import { useEquiposAdicionales } from "@/store/erp";
import { toast } from "react-toastify";

interface ModalEquiposAdicionalesVentaUbicacionProps {
  onChange: (e: IDataProducto|IUbicacionProducto) => void;
  iconButton?: boolean;
  textButton?: string;
  onlyShow?: boolean;
  ubicacionFlota?: string;
  queryStringToSearch?: string;
}

export default function ModalEquiposAdicionalesVentaUbicacion({
  iconButton = false,
  onChange,
  textButton = "Agregar Item",
  onlyShow = false,
  ubicacionFlota,
  queryStringToSearch = "descripcion"
}: ModalEquiposAdicionalesVentaUbicacionProps) {
  ///* State
  const [openModalProducto, setOpenModalProducto] = useState<boolean>(false);
  const { columnsEquipoAdicionalUbicacion } = useTableColumnsProducto();
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();
  const productos = useEquiposAdicionales(s => s.productos)

  const {
    globalFilter,
    pagination,
    onChangeFilter,
    searchTerm,
    setPagination,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  //FETCH
  const {
    isLoading: isloadingProducto,
    data: productoRes,
    isRefetching: isRefetchingProducto
  } = useFetchUbicacionProductoSimple({
    enabled: true,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      [queryStringToSearch]: searchTerm.toUpperCase(),
      estado: true,
      filterByState: false,
      es_para_venta: true,
      ubicacion: ubicacionFlota,
      ...filterObject,
    }
  });

  useLoaders(isloadingProducto);

  return (
    <>
      {
        onlyShow?null:
        iconButton ? (
          <Tooltip placement="top" title="Todos los inventariables">
            <IconButton onClick={() => setOpenModalProducto(true)} size="medium">
              <ManageSearchIcon />
            </IconButton>
          </Tooltip>
          ) : (
          <Button
            startIcon={ <AddIcon />}
            variant="outlined"
            onClick={() => {
              setOpenModalProducto(true);
            }}
          >
              {textButton}
          </Button>
        )
      }

      {openModalProducto && (
        <ScrollableDialogProps
          open={openModalProducto}
          title="Seleccionar"
          //cancelTextBtn="Cerrar"
          onCloseIcon={() => {
            setOpenModalProducto(false);
          }}
          minWidth="60%"
          contentNode={
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <SearchComponente
                  onChange={onChangeFilter}
                  value={globalFilter}
                  text="por descripción inventariable." />
              </Grid>
              
              <Grid item xs={12}>
                <GeneralTable<IUbicacionProducto>
                  columns={columnsEquipoAdicionalUbicacion}
                  data={productoRes?.data.data || []}
                  isLoading={isloadingProducto}
                  isRefetching={isRefetchingProducto}
                  enableGlobalFilter={false}
                  pagination={pagination}
                  onPaging={setPagination}
                  rowCount={productoRes?.data?.count}
                  actionsColumnSize={120}
                  canDelete={false}
                  positionActionsColumn='first'
                  enableColumnActions={true}
                  canAdd={true}
                  canEdit={false}
                  onAdd={e => {
                    const data = e as IUbicacionProducto
                    const repeatedItemNumber = data?.producto_data?.id_producto && productos.filter(
                      inlist => inlist.id == data!.producto_data!.id_producto).length || 0
                    if( repeatedItemNumber >= (data.cantidad||0)){
                      return toast.error("No se puede agregar más de " + parseInt(`${data?.cantidad||"0"}`) + " unidad/es.")
                    }
                    onChange(e.producto_data as IDataProducto);
                  }}
                  density="comfortable"
                  enableTopToolbar={false}

                  ///* filters - server side
                  enableSorting={false}
                  enableManualFiltering={true}
                  columnFilters={columnFilters}
                  onColumnFiltersChange={setColumnFilters}

                />
              </Grid>
            </Grid>
          }
        />
      )}
    </>
  );
}
